import Core from './Core';

import User from './User';

import Raven from 'raven-js';

class ErrorManager 
{
    static Instance = new ErrorManager();

    constructor()
    {
        Raven.config('https://cd79f551c0574bed84d6f8389a79bdf3@sentry.io/1315228').install();
    }


    Handle(data, show = true)
    {
        if(data.code == 403)
        {
            Core.Instance.isLogged = false;
            User.Erase();
            this.Error("Vous devez vous authentifier pour utiliser cette application.");
            window.location.replace("/login");
            return;
        }
        Raven.captureException(data);
        if(!show)
            return;
        if(data instanceof Error)
            this.Error(data.message);
        else 
            this.Error(data);
    }

    Prompt(size = -1, title = "", base = "")
    {
        let value = window.prompt(title, base);
        if(value == null)
        {
            window.location.reload();
            return;
        }
        if(size != -1 && value.length > size)
        {
            ErrorManager.Instance.Error("Ce champ doit contenir moins de "+size+" caractères.");
            return this.Prompt(size);
        }
        return value;
    }


    Error(message)
    {
        console.log(message);
        alert(message);        
    }

    Info(message)
    {
        console.log(message);
        alert(message);
    }
}

export default ErrorManager;


// WEBPACK FOOTER //
// ./src/Core/ErrorManager.js